import { render, staticRenderFns } from "./EditInvoiceItemPage.vue?vue&type=template&id=64699764&"
import script from "./EditInvoiceItemPage.vue?vue&type=script&lang=js&"
export * from "./EditInvoiceItemPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports